/* ======================================================================== */
/* 66. runOnHighPerformanceGPU */
/* ======================================================================== */
function runOnHighPerformanceGPU() {

	const webGLCanvas = document.getElementById('js-webgl');

	if (!Modernizr.touchevents && webGLCanvas) {
		webGLCanvas.getContext('webgl', {
			powerPreference: 'high-performance'
		});
	}

}
